<!-- 价格明细 -->
<template>
  <van-popup
    v-model="show"
    round
    closeable
    position="bottom"
    z-index="109"
    class="price_detail_popup"
    :style="{ height: '60%' }"
    @close="handleClose"
  >
    <div class="price_detail_wrap">
      <div class="price_title van-hairline--bottom">{{ title }}</div>
      <div
        v-if="list.length > 0"
        class="price_detail"
      >
        <div
          class="price_detail_item van-hairline--bottom"
          v-for="item of list"
          :key="item.uid"
        >
          <div class="pro_name">{{ item.goods_name }}</div>
          <div class="pro_number">
            <span class="count_icon">X</span>{{ item.quantity }}
          </div>
          <div class="price_num">{{currency}}{{ item.price * item.quantity }}</div>
        </div>
        <div class="total_price">
          <div class="total_name">{{$t('footerbtn.total')}}</div>
          <div class="total_price">{{currency}}{{ payable }}</div>
        </div>
      </div>
      <van-empty
        v-else
        :description="$t('footerbtn.empty')"
      />
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题',
    },
    list: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    payable: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '￥'
    }
  },
  name: 'PriceDetail',
  data() {
    return {}
  },

  components: {},

  methods: {
    // 关闭
    handleClose() {
      this.$emit('listenHandleClosePriceDetail')
    },
  },

  mounted() { },
}
</script>
<style lang="less" scoped>
.price_detail_popup {
  z-index: 110 !important;
}
.price_detail_wrap {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .price_title {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    // margin: 15px 0;
    padding: 15px 40px;
    letter-spacing: 1px;
    font-weight: bold;
  }
  .price_detail {
    flex: 1;
    padding: 0 15px;
    margin-bottom: 80px;
    overflow-y: auto;
    .price_detail_item {
      height: 46px;
      font-size: 14px;
      display: flex;
      .pro_name {
        line-height: 46px;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
      }
      .pro_number {
        line-height: 46px;
        flex: 1;
        .count_icon {
          display: inline-block;
          margin: 0 5px;
          font-size: 12px;
        }
      }
      .price_num {
        font-size: 14px;
        line-height: 46px;
      }
    }
    .total_price {
      height: 46px;
      overflow: hidden;
      color: #ed4014;
      .total_name {
        font-size: 14px;
        font-weight: bold;
        float: left;
        line-height: 46px;
      }
      .total_price {
        float: right;
        font-size: 14px;
        font-weight: bold;
        line-height: 46px;
      }
    }
  }
}
</style>
